var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "calendar-color-field" },
    [
      _vm.title
        ? _c(_setup.CalendarFieldTitle, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "color-row rounded",
          class: { disabled: _vm.disabled },
          on: { click: _setup.togglePicker },
        },
        [
          _c("span", {
            staticClass: "color-preview",
            style: {
              backgroundColor: _setup.color.hex,
              opacity: _setup.color.alpha,
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "flex-fill" }, [
            _vm._v(_vm._s(_setup.color.hex.toUpperCase())),
          ]),
          _vm._v(" "),
          _c("font-awesome-icon", { attrs: { icon: ["far", "pen"] } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.ColorSelector, {
        ref: "pickerRef",
        attrs: { open: _setup.clickOutsideActive, color: _setup.color },
        on: {
          cancel: _setup.togglePicker,
          "color-selected": _setup.onColorSelected,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }